import { sendPost } from '@/utils/request.js';
import { unionFlag } from './../utils';
// 获取城市列表
function getCityData(data) {
  const url = '/location/citylist';
  return sendPost({ url, data, baseURL: false, applicationType: false });
}

// 获取公告
function getNotice(data) {
  const url = '/notice/noticeContent';
  return sendPost({ url, data });
}

// 获取快速搜索
function getQuickSearch(data) {
  // const url = '/search/quick';
  const url = '/search/searchContract/quick/v2';
  return sendPost({ url, data });
}

// 获取搜索词链
function getSearchUrl(data) {
  const url = '/word/super';
  return sendPost({ url, data });
}

// 查询是否敏感词
function getSensitiveUrl(data) {
  const url = '/word/sensitive';
  return sendPost({ url, data });
}


// 获取新工会头部数据
function getFindByUnion(data) {
  const url = '/mallUnion/unionConfig/findByUnion';
  return sendPost({ url, data, Business: false });
}


// 获取登录状态
function getLoginStatus() {
  let params = {
    union: '',
    unionFlag: 0,
  };
  let union = unionFlag() || sessionStorage.getItem('dffl_union');
  
  if(union){
    params = {
      union,
      unionFlag: 1,
    };
  }
  const url = '/user/checkLogin';
  return sendPost({ url, params, baseURL: false, applicationType: false });
}
// 获取登录状态
function getLoginOut() {
  let params = {
    union: '',
    unionFlag: 0,
  };
  let union = unionFlag() || sessionStorage.getItem('dffl_union');
  if(union){
    params = {
      union,
      unionFlag: 1,
    };
  }
  const url = '/user/loginOut';
  return sendPost({ url, params, baseURL: false, applicationType: false });
}
// 获取工会菜单
function getFindUsableList(data) {
  const url = '/mallUnion/unionMallConfig/findUsableList';
  return sendPost({ url, data, Business: false });
}

//
function getIsNewUnion(data) {
  const url = '/mallUnion/union/isNewUnion';
  return sendPost({ url, data });
}

// 获取老公会信息
function getLogo(data) {
  const url = '/mallunion/getLogo';
  return sendPost({ url, data, baseURL: false, applicationType: false });
}

function getDefaultAddress(data) {
  const url = '/trade/addressContract/getDefaultAddress';
  return sendPost({ url, data, baseURL: true, applicationType: true });
}
export default {
  getCityData,
  getNotice,
  getQuickSearch,
  getFindByUnion,
  getLoginStatus,
  getFindUsableList,
  getIsNewUnion,
  getLogo,
  getDefaultAddress,
  getLoginOut,
  getSearchUrl,
  getSensitiveUrl,
};
